import { render, staticRenderFns } from "./GeneralAdminOverviewInfo.vue?vue&type=template&id=30beaafe&scoped=true&"
import script from "./GeneralAdminOverviewInfo.vue?vue&type=script&lang=js&"
export * from "./GeneralAdminOverviewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30beaafe",
  null
  
)

export default component.exports